import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

import { ref, computed, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber } from '@/utils/index'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 账户余额_分页查询
  'POST/financial_bank_balance/query': fetchList,
  // 账户余额_导出
  'POST/financial_bank_balance/download': exportApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const cloumnsDate: any = computed(() => {
  return MI_tableData.value.length > 0 ? MI_tableData.value[0]?.bankBalanceList : []
})

const searchEle = ref()
const searchFormObject = reactive({
  companies: [],
  bankName: '',
  timgRange: [dayjs().subtract(1, 'year').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
})

let dropObj: any = reactive({
  // 账户ID
  "accountNumber": [],
  // 账户简称
  "accountName": [],
  // 银行简称
  "bankName": [],
  // 公司名称
  "company": [],
  // 币种
  "currency": [],
})

// 默认不搜索
const searchHandle = (params: any) => {
  // 判断日期是否大于12个月
  let startDay = dayjs(params.timgRange[0]).format('YYYY-MM')
  let endDay = dayjs(params.timgRange[1]).format('YYYY-MM')
  if(Math.abs(dayjs(startDay).diff(dayjs(endDay), 'month')) > 12 ){
    ElMessage.warning('交易日期间隔不能大于12个月')
    return
  }
  fetchData({
    query: {
      companies: params.companies, 
      bankName: params.bankName,
      collectionAt: {
        from: params.timgRange?.[0],
        to: params.timgRange?.[1],
      },
    }
  })
}


onBeforeMount(() => {
  getDropBoxHandle().then((rep: any) => {
    for (const key in rep) {
      dropObj[key] = [...rep[key]]
    }
  })
})

const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = ['合计', '', '', '']
  
  columns.forEach((column: any, index: any) => {
    if([0, 1, 2, 3].includes(index)) return;
    
    const values = data.map((item: any) => Number(item.bankBalanceList[Math.floor((index - 4) / 2)][column.property]))
    
    if (!values.every((value: any) => Number.isNaN(value))) {
      sums[index] = getNumber(values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
    } else {
      sums[index] = 'N/A'
    }
  })

  return sums
}



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "账户余额" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _unref(searchFormObject),
              inline: "",
              ref_key: "searchEle",
              ref: searchEle,
              disabled: _unref(MI_identify),
              class: "searchBg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "银行名称:",
                  prop: "bankName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "form-input",
                      filterable: "",
                      modelValue: _unref(searchFormObject).bankName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchFormObject).bankName) = $event)),
                      placeholder: "请选择银行名称",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).bankName, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            key: item.id,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司名称:",
                  prop: "companies"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      multiple: "",
                      "collapse-tags": "",
                      style: {"width":"330px"},
                      class: "form-input",
                      filterable: "",
                      modelValue: _unref(searchFormObject).companies,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchFormObject).companies) = $event)),
                      placeholder: "请选择公司名称",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).company, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            key: item.id,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "交易日期:",
                  prop: "timgRange"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchFormObject).timgRange,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchFormObject).timgRange) = $event)),
                      type: "daterange",
                      "disabled-date": (time) => time.getTime() > Date.now(),
                      "unlink-panels": "",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      placeholder: "请选择交易日期"
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle(_unref(searchFormObject))))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_eptBtn, {
      exportFn: _unref(exportApi),
      exportText: '导出账户余额',
      exportParam: _unref(MI_params).query,
      class: "mt-5 mb-5",
      disabled: _unref(MI_identify)
    }, null, 8, ["exportFn", "exportParam", "disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      "show-summary": "",
      "summary-method": getSummaries,
      "max-height": _unref(MI_height) - 80 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "公司名称",
          prop: "company",
          "show-overflow-tooltip": "",
          "min-width": "150",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "银行名称",
          prop: "bankName",
          width: "135",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "90",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "账号",
          prop: "accountId",
          "show-overflow-tooltip": "",
          "min-width": "150"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cloumnsDate), (date, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: date.balanceTime,
            label: date.balanceTime,
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "期末余额",
                prop: "endingAmount",
                align: "right",
                width: "150"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(getNumber)(row.bankBalanceList[index].endingAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "期末本位币余额",
                prop: "endingCurrencyAmount",
                align: "right",
                width: "150"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(getNumber)(row.bankBalanceList[index].endingCurrencyAmount)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 100, 200, 500],
      layout: "sizes, prev, pager, next, total",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})